import axios from 'axios'

axios.interceptors.response.use(
  function (config) {
    return config
  },
  function (error: any) {
    const status = error.response?.status
    // Leave 404 responses as axios errors so callers can treat "not found"
    // as an expected state (e.g. logged out) instead of a user-facing exception.
    if (status !== 404) {
      const detail = error.response?.data?.detail
      if (detail) {
        throw new Error(detail)
      }
    }
    return Promise.reject(error)
  },
)

export default axios
